<template >
    <div>
      <div class="financasContainer" @click="abrirPopup()"></div>
    
      <div class="popup" :style="{ top: popupVisible ? '0' : '-100%' }">
        <div class="popup-content" v-if="!demostracao">
          <h2 class="titulo_">Softline Angola</h2>
          <!-- <p>Na Softline, estamos comprometidos em tornar a gestão das escolas mais eficiente e os processos educacionais mais acessíveis. Oferecemos uma gama de soluções inovadoras para atender às necessidades específicas das instituições de ensino.</p>

          <p>Nossos principais sistemas incluem:</p> -->

          <ul>
            <li><strong>Eltsys Faturação:</strong> Simplificamos as finanças escolares para você, permitindo um controle eficiente de receitas, despesas e faturas.</li>
            <!-- <li><strong>Controle de Devedores por Leitor de Barra à Entrada: </strong> Reforçamos a segurança na portaria da escola, fornecendo informações instantâneas sobre o status dos alunos, garantindo um acesso seguro e simples."</li>
            <li><strong>Sistema Acadêmico Local:</strong> Oferecemos flexibilidade com uma instalação local, mantendo o controle completo dos processos acadêmicos.</li> -->
          </ul>

          <span>Agende uma apresentação ligando para <strong>948105702</strong></span>
  
          <div class="btnContainer">
            <button class="btn btnFechar" @click="fecharPopup()">Fechar</button>
            <!-- <button class="btn btnAgendar" @click="agendarDemostracao()" >Agendar Demostração</button> -->
          </div>
        </div>
  
        <template v-if="demostracao">
          <v-row justify="center">
            <v-dialog v-model="demostracao" persistent max-width="500">
              <v-card>
                <v-card-title class="text-h5" style="background-color:#006699;color:white;"> Agendar Demostração </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col md="12"></v-col>
                    <v-col md="12">
                      <v-text-field v-model="usuarioLogado" disabled outlined></v-text-field>
                      <div>
                        <div class="checkContainer" v-for="sistema in sistemas" :key="sistema.id">
                          <input type="checkbox" :id="sistema.id" v-model="sistema.checked">
                          <label :for="sistema.id">{{ sistema.descricao }}</label>
                          <abbr class="more_info_icon" :title="sistema.detalhe"><v-icon>info</v-icon></abbr>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="darken-1" text @click="fecharPopup()"> Fechar </v-btn>
                  <v-btn color="green darken-1" text @click="enviarEmail()"> Agendar </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </div>
    </div>
  </template>
  
  <script>
  const ls = require('local-storage')
  import Swal from 'sweetalert2';
  import axios from '../../plugins/axios'
  export default {
    data: () => ({
      popupVisible: false,
      demostracao: false,
      sistemas: [
        {id: 1, checked: true, descricao: 'Sistema Financeiro', detalhe: 'mais detalhes do finaceiro'},
        {id: 2, checked: false, descricao: 'Sistema Acádemico local', detalhe: 'mais detalhes do academico local'},
        {id: 3, checked: false, descricao: 'Controle de devedores por leitor de barra a entrada!', detalhe: 'mais detalhes do pagamento na porta'}
      ],
      sistemasSelected: []
    }),
  
    methods: {
      abrirPopup() {
        this.popupVisible = true;
      },
      fecharPopup() {
        this.popupVisible = false;
        this.demostracao = false;
      },
      agendarDemostracao() {
        this.demostracao = true;
      },
      
      async enviarEmail() {
        this.sistemasSelected = this.sistemas.filter((s) => s.checked === true);
        if (this.sistemasSelected.length){
            console.log('selecionado');
            let email = await axios.post('/enviarEmail', {corpo:'nehu sonehru', destino: 'sonehru@gmail.com'}).then((res) => res.data)

            console.log(email);
            // Swal.fire('Sucesso', 'Seu email foi enviado com sucesso!', 'success');
        } else {
            console.log('nada selecionado');
        }
      }
    },
  
    computed: {
      usuarioLogado() {
        return ls.get('nomeUsuario')
      }
  
    }
  
  }
  </script>
  
  <style scoped>
  .financasContainer {
    margin: 10px auto;
    width: 99%;
    height: 90vh;
    background-image: url('/img/sistemafinanceiro.png');
  }
  
  .popup {
    position: fixed;
    top: -100%;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    transition: top 0.3s ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  span {
    font-size: 12px;
    display: block;
  }
  
  .popup-content {
    background: #fff;
    padding: 5px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    width: 65%;
    margin-left: 200px;
  }
  
  .popup-content p,
  .popup-content ul,
  .popup-content span {
    text-align: justify;
    width: 90%;
    margin: 0 auto;
  }

  .popup-content .titulo_ {
    font-size: 16px;
    text-align: center;
  }
  
  .btnContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 500px;
    margin: 10px auto 0;
  }
  
  .btn {
    padding: 5px;
    width: 200px;
    border-radius: 10px;
    color: #fff;
    transition: all .5s;
  }
  
  .btn:hover {
    transition: all .5s;
    background-color: #4d4b4b;
  }
  
  .btnFechar {
    background-color: #fc5a5a;
    margin-right: 5px;
  }
  
  .btnAgendar {
    background-color: #5858ca;
  }
  
  .checkContainer {
    display: flex;
    align-items: center;
  }
  
  .checkContainer label {
    margin-left: 5px;
    cursor: pointer;
  }

  .checkContainer input[type="checkbox"] {
    cursor: pointer;
  }
  .more_info_icon {
    margin-left: 3px;
    cursor: pointer;
  }
  </style>
  